
import React, { useEffect, useState } from "react";
import { onConnectionStateChange } from "@/services/firebase";
import { Wifi, WifiOff } from "lucide-react";

export const ConnectionStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check initial connection status
    setIsOnline(navigator.onLine);
    
    // Set up listeners for online/offline events
    const handleOnline = () => {
      console.log("ConnectionStatus: Browser is online");
      setIsOnline(true);
      setShowBanner(true);
      // Hide the banner after 3 seconds
      setTimeout(() => setShowBanner(false), 3000);
    };
    
    const handleOffline = () => {
      console.log("ConnectionStatus: Browser is offline");
      setIsOnline(false);
      setShowBanner(true);
    };
    
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    // Also listen to our Firebase connection state
    const unsubscribe = onConnectionStateChange((isConnected: boolean) => {
      console.log("ConnectionStatus: Firebase connection state changed:", isConnected);
      setIsOnline(isConnected);
      setShowBanner(!isConnected);
    });
    
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      unsubscribe();
    };
  }, []);
  
  if (!showBanner) return null;
  
  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 z-50 p-4 ${
        isOnline ? "bg-green-500" : "bg-red-500"
      } text-white flex items-center justify-center transition-all duration-300`}
    >
      <div className="flex items-center gap-2 mx-auto max-w-3xl">
        {isOnline ? (
          <>
            <Wifi className="h-5 w-5" />
            <span>You're back online</span>
          </>
        ) : (
          <>
            <WifiOff className="h-5 w-5" />
            <span>You're offline. Some features may be unavailable.</span>
          </>
        )}
      </div>
    </div>
  );
};

export default ConnectionStatus;
